import { render, staticRenderFns } from "./layout-product-details-tabs.vue?vue&type=template&id=30a0d063&scoped=true&"
import script from "./layout-product-details-tabs.vue?vue&type=script&lang=js&"
export * from "./layout-product-details-tabs.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-details-tabs.vue?vue&type=style&index=0&id=30a0d063&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0d063",
  null
  
)

export default component.exports